import "./404.scss";

import Error404 from "./404";

export default Error404;
